// deno-fmt-ignore-file
import { Guard } from '../../guard/index.mjs';
export function GetAdditionalProperties(type) {
    const additionalProperties = Guard.HasPropertyKey(type, 'additionalProperties') ? type.additionalProperties : undefined;
    return additionalProperties;
}
